import websiteRouter from './website.router';
import brushFaceRouter from './face.router';
import newwebsite from './newwebsite.router';
import website_v3 from './website_v3.router';
import { project_env } from '../defaultSettings';

const routerConfig = {
  website: websiteRouter,
  brush: brushFaceRouter,
  newwebsite,
  website_v3,
};

export default routerConfig[project_env];
